var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OttWidget',[_c(_vm.widgetComponent,{tag:"component",attrs:{"contactSectionOverride":_vm.contactSection,"aboutSectionOverride":_vm.aboutSection,"socialSectionOverride":_vm.socialSection,"feedbackSectionOverride":_vm.feedbackSection,"apiServer":_vm.apiServer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }